<div class="organization-area-component-wrapper">
    <div class="area-header-wrapper">
        <app-area-header
            *ngIf="isInAnyOrg && profilePicture"
            [largeHeadline]="largeHeadline"
            [smallHeadlineTranslationKey]="smallHeadlineTranslationKey"
            [profilePicture]="profilePicture"
            [smallHeadlineRaw]="null"
            [smallHeadlineIconPath]="null"
            [enablePictureUpload]="false"
            (pictureSelected)="(null)"
        ></app-area-header>
    </div>
    <div class="page-window d-flex flex-column flex-grow-1" *ngIf="isInAnyOrg">
        <div class="d-flex flex-column flex-shrink-0">
            <div class="d-flex selection-header">
                <div
                    id="details-tab"
                    *ngIf="hasOrganizationFeature"
                    [ngClass]="{ dragBox: true, selected: tabIndex === 0 }"
                    (click)="onSelectTab(0)"
                    [tabIndex]="0"
                    (keydown.enter)="onSelectTab(0)"
                >
                    <div class="background"></div>
                    <div class="tab-text">
                        {{
                            'organization.organizationArea.tabs.details'
                                | translate
                        }}
                    </div>
                </div>
                <div
                    *ngIf="hasOrganizationFeature"
                    id="member-tab"
                    [ngClass]="{ dragBox: true, selected: tabIndex === 1 }"
                    (click)="onSelectTab(1)"
                    [tabIndex]="0"
                    (keydown.enter)="onSelectTab(1)"
                >
                    <div class="background"></div>
                    <div class="tab-text">
                        {{
                            'organization.organizationArea.tabs.member'
                                | translate
                        }}
                    </div>
                </div>
                <div
                    *ngIf="hasOrganizationFeature && isOrgSuperAdmin"
                    id="subscription-tab"
                    [ngClass]="{ dragBox: true, selected: tabIndex === 2 }"
                    (click)="onSelectTab(2)"
                    [tabIndex]="0"
                    (keydown.enter)="onSelectTab(2)"
                >
                    <div class="background"></div>
                    <div class="tab-text">
                        {{
                            'organization.organizationArea.tabs.subscription'
                                | translate
                        }}
                    </div>
                </div>
                <div
                    *ngIf="hasOrganizationFeature && isOrgSuperAdmin"
                    id="credits-tab"
                    [ngClass]="{ dragBox: true, selected: tabIndex === 3 }"
                    (click)="onSelectTab(3)"
                    [tabIndex]="0"
                    (keydown.enter)="onSelectTab(3)"
                >
                    <div class="background"></div>
                    <div class="tab-text">
                        {{
                            'organization.organizationArea.tabs.credits'
                                | translate
                        }}
                    </div>
                </div>
            </div>
        </div>
        <div
            class="selected-tab-component-wrapper d-flex flex-column flex-grow-1 overflow-hidden"
        >
            <app-organization-details-page
                *ngIf="tabIndex === 0 && hasOrganizationFeature"
                [orgId]="orgId"
            ></app-organization-details-page>
            <app-organization-members-page
                *ngIf="tabIndex === 1 && hasOrganizationFeature"
            ></app-organization-members-page>
            <app-subscriptions-page
                *ngIf="
                    tabIndex === 2 && hasOrganizationFeature && isOrgSuperAdmin
                "
                context="organization"
                [userId]="userId"
                [activeOrganization]="activeOrganization"
            ></app-subscriptions-page>
            <app-organization-credits-page
                *ngIf="
                    tabIndex === 3 && hasOrganizationFeature && isOrgSuperAdmin
                "
            ></app-organization-credits-page>
        </div>
    </div>
    <div class="organization-creation-page" *ngIf="!isInAnyOrg">
        <div class="create-organization button-wrapper-tryb-button">
            <p class="organization-creation-description">
                {{
                    'organization.organizationArea.createOrganization.description'
                        | translate
                }}
            </p>
            <button
                type="button"
                class="button-tryb-button basic-tryb-button"
                (click)="openOrganizationCreationModal()"
            >
                {{
                    'organization.organizationArea.createOrganization.button'
                        | translate
                }}
            </button>
        </div>
    </div>
</div>
